import { Row, Col } from "../../App.styles";

const Background = ({ useQuery }) => {
  const { overlay_thumb, txt } = useQuery();

  return (
    <Row>
      <Col>
        <p>
          Background: <img src={overlay_thumb} alt={txt} />
        </p>
      </Col>
    </Row>
  );
};

export default Background;
